module.exports = __webpack_public_path__ + "img/stock1.8e4701f0.png";